<div id="returns" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="orderNumber+orderSuffix" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper margin-t-x0">
      </div>

      <div class="inner-subBlock-wrapper margin-t-x0">
        <!--        <div class="row">-->
        <!--          <div class="col-sm">-->
        <!--            <mat-radio-group [(ngModel)]="returnOption">-->
        <!--              <mat-radio-button value="full" class="radio-text" style="font-size: 10px !important">Full Return</mat-radio-button>-->
        <!--              <mat-radio-button class="margin-l-x10 radio-text" value="partial" style="font-size: 10px !important">Partial Return</mat-radio-button>-->
        <!--            </mat-radio-group>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="row margin-t-x20">-->
        <!--          <div class="col-sm">-->
        <!--            <label class="font-x10 font-color-g3">ORDER NUMBER* </label><br />-->
        <!--          </div>-->

        <!--        </div>-->
        <!--        <div class="row">-->
        <!--          <div class="col-sm">-->
        <!--            <input class="po-reference width-95" id="inputOrderNumber" type="text" [(ngModel)]="orderNumber"-->
        <!--                   name="orderNumber">-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="row margin-t-x20">-->
        <!--          <div class="col-sm">-->
        <!--            <label class="font-x10 font-color-g3">ORDER SUFFIX </label><br />-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="row">-->
        <!--          <div class="col-sm">-->
        <!--            <input class="po-reference width-200" type="text" [(ngModel)]="orderSuffix" name="orderSuffix">-->
        <!--          </div>-->
        <!--          <div class="col-sm">-->
        <!--            <a class="list-group-item" (click)="getReturnOrders()">-->
        <!--              Get details</a>-->
        <!--          </div>-->
        <!--        </div>-->
        <div *ngIf="loadContent">
          <div class="row  width-100 margin-t-x30 dropdownBox">
            <div class="col-sm">
              <label class="font-x10 font-color-g3">REASON*</label><br/>
              <mat-form-field>
                <mat-select class="reasonValidate" [(value)]="selectedReason" id="reasonsDropDown">
                  <mat-option value="{{reason.text}}" *ngFor="let reason of reasonList">{{reason.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="selectedReason === 'DOA'">
            <div class="col-sm">
              <label class="font-x10 font-color-g3">DOA VENDOR REF</label><br/>
              <input class=" width-90 po-reference" type="text" [(ngModel)]="venderRefNumber" name="vendorRef">
            </div>
          </div>
          <div class="row width-100 margin-t-x30 ">
            <div class="col-sm">
              <label class="font-x10 font-color-g3">GOODS CONDITION*</label><br/>
              <mat-form-field>
                <mat-select class="conditionValidate" [(value)]="selectedCondition" id="conditionsDropDwon">
                  <mat-option value="{{condition.text}}" *ngFor="let condition of goodsConditionList">{{condition.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row  width-100 margin-t-x30 dropdownBox">
            <div class="col-sm">
              <label class="font-x10 font-color-g3">FULL RETURN / PARTIAL RETURN* </label><br/>
              <mat-form-field>
                <mat-select [(value)]="returnOption" id="returnsDropDown"
                            (selectionChange)="onReturnSelect($event.value)">
                  <mat-option value="{{return.value}}"
                              *ngFor="let return of returnList">{{return.displayText}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row margin-t-x30">
            <div class="shared-outer-wrapper" style="width:100%; margin-left: 10px; margin-right:10px">
              <table class="white">
                <thead>
                <tr class="row">
                  <th class="col-2">STOCK CODE</th>
                  <!--                  <th class="col-1"></th>-->
                  <th class="col-5 pl-40">DESCRIPTION</th>
                  <th class="col-1" style="max-width:15%">QTY</th>
                  <th class="col-2 text-right">UNIT VALUE</th>
                  <th class="col-2">RETURNED VALUE</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let order of originalOrders;index as i">

                  <tr class="row">
                    <div class="col-2 align-left" style="padding-right: 25px;">
                      <span *ngIf="returnOption === 'full'||returnOption === ''"> {{order?.stockcode}}</span>

                      <mat-checkbox *ngIf="returnOption === 'partial'" [(ngModel)]="order.selected"
                                    (change)="onStockCodeChange($event.checked, order)"
                      > {{order?.stockcode}}
                      </mat-checkbox>
                    </div>
                    <!--                    <div class="col-1"></div>-->
                    <div class="col-5 align-left pl-40">
                      {{order?.description}}

                    </div>
                    <div class="col-1 align-left pl-25" style="max-width:14%">

                      <ng-container
                        *ngIf="returnOption === 'full' || returnOption === '' || order.serials.length>0||(order.serials.length==0 && order.orderQty=='1');else partial">
                        <span>{{order?.returnQty}}</span>
                      </ng-container>

                      <ng-template #partial>
                        <input integerOnly
                               [attr.id]="'qty' + order?.stockcode" type="text" class="input-box-small"
                               [(ngModel)]="order.returnQty" (ngModelChangeDebounced)="onReturnQtyChange(order)"/>
                      </ng-template>


                    </div>
                    <div class="col-2 pl-25 text-right">
                      {{order.unitValue | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </div>
                    <div class="col-2 pl-25 text-right">
                      {{ ((returnOption == 'partial' && !order.selected) ? '0' : stringToNumber(order.unitValue,'float') *stringToNumber(order.returnQty,'int')) | currency:'AUD':'symbol-narrow':'.2-2'}}
                    </div>
                    <ng-container *ngIf="order.serials.length>0">
                      <div class="col-2"></div>
                      <div class="col-8 pl-40">
                        <div class="row">
                          <ng-container *ngFor="let serial of order.serials">

                          <span class="col-4"
                                *ngIf="returnOption === 'full'||returnOption === ''"> {{ serial.serialNumber }}
                          </span>


                            <mat-checkbox class="col-4 h-22" *ngIf="returnOption === 'partial'"
                                          (change)="onSerialsChange(serailCbk.checked, serial, order)"
                                          [checked]="serial.selected" #serailCbk> {{ serial.serialNumber }}
                            </mat-checkbox>

                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </tr>

                  <!--                  <ng-container *ngIf="order.serials.length>0">-->
                  <!--                    <tr class="row no-top-border">-->
                  <!--                      <td class="col-3"></td>-->
                  <!--                      <td class="col-8">-->
                  <!--                        <ng-container *ngFor="let serial of order.serials">-->
                  <!--                          <div class="my-3 row">-->

                  <!--                          <span class="col-4"-->
                  <!--                                *ngIf="returnOption === 'full'||returnOption === ''"> {{ serial.serialNumber }}-->
                  <!--                          </span>-->

                  <!--                            <mat-checkbox class="col-4" *ngIf="returnOption === 'partial'"-->
                  <!--                                          (change)="onSerialsChange(serailCbk.checked, serial, order)"-->
                  <!--                                          [checked]="serial.selected" #serailCbk> {{ serial.serialNumber }}-->
                  <!--                            </mat-checkbox>-->

                  <!--                          </div>-->
                  <!--                        </ng-container>-->

                  <!--                      </td>-->
                  <!--                    </tr>-->
                  <!--                  </ng-container>-->


                </ng-container>
                <tr class="row totalPrice-wrapper">
                  <div class="col-md offset-md-7">Returns Total</div>
                  <div class="col-md price">{{ getTotal() | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                  <!-- <div class="col-md price">{{orderDetail?.orderTotalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</div> -->
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row margin-t-x30">
            <div class="col-sm">
              <textarea class="note-wrapper input no-border form-control" cols="20" id="comments" name="comments"
                        rows="8"
                        placeholder="Please provide any further details that may assist us in processing your return request"
                        onfocus="this.placeholder=''"
                        onblur="this.placeholder='COMMENTS'" [(ngModel)]="comments"></textarea>
            </div>
          </div>
          <div class="row margin-t-x30">
            <div class="col-sm">
              <!--              <label class="font-x10 font-color-g3">ATTACH DOCUMENTS</label><br />-->
              <section>
                <label for="upload" class="attachmentSection">
                  <img class="img" src="../images/new_ui/attachment-hover.png" alt="">
                  <input type="file" name="image" accept="image/*" id="upload" style="display:none"
                         (change)="onSelectFile($event)">
                  <span
                    style="margin-left: 10px; text-transform: capitalize; font-weight: normal;">ATTACH DOCUMENTS</span>
                </label>
                <br/>


              </section>
              <!--              <p class="small-text">Eg: Photos of damaged goods, vendor RMA documentation etc.</p>-->
              <!--              <section>-->
              <!--                <label for="upload" class="attachmentSection">-->
              <!--                  <img class="img" src="../images/new_ui/attachment-hover.png" alt="">-->
              <!--                  <input type="file" name="image" accept="image/*" id="upload" style="display:none"-->
              <!--                         (change)="onSelectFile($event)">-->
              <!--                  <span style="margin-left: 10px; text-transform: capitalize; font-weight: normal;">Choose Files</span>-->
              <!--                </label>-->

              <!--                 <label class="fileListSection">{{ chooseFileMessage }}</label> -->
              <!--              </section>-->
            </div>

          </div>
          <div class="row no-gutters mt-2">
            <p class="small-text">Eg: Photos of damaged goods, vendor RMA documentation etc.</p>
          </div>
          <div class="row">
            <label class="fileListSection">{{ imageFile ? imageFile.name : chooseFileMessage }} <span *ngIf="imageFile"
                                                                                                      id="delete-btn"
                                                                                                      (click)="deleteAttachment()"
                                                                                                      class="basic-icon delete-icon  center-text"></span></label>
          </div>
          <div class="row margin-t-x30">
            <button class="button button-red button-large" [disabled]="disableSending" id="btnSendReturn"
                    (click)="sendReturnForm()">Send return form
            </button>
          </div>
        </div>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='820' [scrollAfterLoading]="true" [showBlurTable]="true"
                    (currentLoadingStatus)="onLoading($event)"></loading-screen>
    <loading-screen *ngIf="!finishSending" backDropWidth='1080' [scrollAfterLoading]="true"></loading-screen>
  </div>
</div>
